export enum CalendarItemStatus {
    COMPLETE = "Complete",
    IN_PROGRESS = "In Progress",
    PENDING = "Pending"
}